
import React, { useEffect } from "react";
import { affiliateApi } from "../influencer/services/influancerService";

const Tracker = () => {
  useEffect(() => {
    const trackPaymentVisit = async () => {
      try {
        // Get stored click ID and shortCode from localStorage
        const clickId = localStorage.getItem('lastClickId');
        const shortCode = localStorage.getItem('shortCode');

        if (clickId && shortCode) {
          // Track the payment page visit
          await affiliateApi.trackPaymentPageVisit(shortCode, clickId);
          
         

          // Fire JavaScript Pixel
          fireJavaScriptPixel(clickId, shortCode);

          // Fire Image Pixel
          fireImagePixel(clickId, shortCode);

           // Clear the stored values after successful tracking
           localStorage.removeItem('lastClickId');
           localStorage.removeItem('shortCode');
           localStorage.removeItem('deviceFingerprint');
        }
      } catch (error) {
        console.error('Error tracking payment visit:', error);
      }
    };

    // JavaScript Pixel Implementation
    const fireJavaScriptPixel = (clickId, shortCode) => {
      try {
        // Create a script element
        const script = document.createElement('script');
        script.type = 'text/javascript';
        
        // Add tracking data to script
        script.innerHTML = `
          (function() {
            const trackingData = {
              clickId: '${clickId}',
              shortCode: '${shortCode}',
              timestamp: new Date().toISOString(),
              referrer: document.referrer,
              userAgent: navigator.userAgent,
              screenResolution: \`\${window.screen.width}x\${window.screen.height}\`,
              viewportSize: \`\${window.innerWidth}x\${window.innerHeight}\`
            };

            // Send tracking data to backend
            fetch('${process.env.REACT_APP_API_URL}/affiliate/pixel-track', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify(trackingData)
            }).catch(console.error);
          })();
        `;

        // Append script to document
        document.body.appendChild(script);
      } catch (error) {
        console.error('Error firing JavaScript pixel:', error);
      }
    };

    // Image Pixel Implementation
    const fireImagePixel = (clickId, shortCode) => {
      try {
        // Create a new image element
        const img = new Image(1, 1);
        img.style.display = 'none';
        
        // Build tracking URL with parameters
        const trackingUrl = new URL(`${process.env.REACT_APP_API_URL}/affiliate/pixel-track.gif`);
        trackingUrl.searchParams.append('clickId', clickId);
        trackingUrl.searchParams.append('shortCode', shortCode);
        trackingUrl.searchParams.append('timestamp', new Date().toISOString());
        trackingUrl.searchParams.append('ref', encodeURIComponent(document.referrer));

        // Set image source and append to document
        img.src = trackingUrl.toString();
        document.body.appendChild(img);
      } catch (error) {
        console.error('Error firing image pixel:', error);
      }
    };

    trackPaymentVisit();
  }, []);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 px-4">
      <div className="bg-white p-8 rounded-2xl shadow-lg text-center w-full max-w-lg">
        <div className="mb-6">
          <img
            src="https://cdn-icons-png.flaticon.com/512/845/845646.png"
            alt="Success"
            className="w-20 h-20 mx-auto mb-4"
          />
          <h2 className="text-2xl font-bold text-gray-800">
            Thank You for Your Purchase!
          </h2>
          <p className="text-gray-600 mt-2">
            Your purchase has been successfully recorded. If you're an affiliate,
            your earnings will be updated shortly.
          </p>
        </div>

        <div className="mt-8 space-y-4">
          <button 
            onClick={() => window.location.href = '/'}
            className="w-full bg-orange-500 text-white py-3 px-6 rounded-lg hover:bg-orange-600 transition duration-200"
          >
            Return to Homepage
          </button>
          
          {/* <button 
            onClick={() => window.location.href = '/earnings'}
            className="w-full bg-gray-100 text-gray-700 py-3 px-6 rounded-lg hover:bg-gray-200 transition duration-200"
          >
            View Earnings
          </button> */}
        </div>

        <div className="mt-8 border-t pt-6">
          <p className="text-sm text-gray-500">
            Having issues with your purchase? 
            <a href="/contact-details" className="text-orange-500 hover:text-orange-600 ml-1">
              Contact Support
            </a>
          </p>
        </div>
      </div>

      {/* Hidden Tracking Pixels */}
      <noscript>
        <img
          src={`${process.env.REACT_APP_API_URL}/affiliate/pixel-track.gif?fallback=true`}
          alt=""
          style={{ display: 'none' }}
          width="1"
          height="1"
        />
      </noscript>
    </div>
  );
};

export default Tracker;










// import { useEffect } from 'react';
// import { affiliateApi } from '../services/api';

// const Tracker = () => {
//   useEffect(() => {
//     const trackPaymentVisit = async () => {
//       try {
//         // Get stored click ID and shortCode from localStorage
//         const clickId = localStorage.getItem('lastClickId');
//         const shortCode = localStorage.getItem('shortCode');

//         if (clickId && shortCode) {
//           // Track the payment page visit
//           await affiliateApi.trackPaymentPageVisit(shortCode, clickId);

//           // Fire JavaScript Pixel
//           fireJavaScriptPixel(clickId, shortCode);

//           // Fire Image Pixel
//           fireImagePixel(clickId, shortCode);

//           // Clear the stored values after successful tracking
//           localStorage.removeItem('lastClickId');
//           localStorage.removeItem('shortCode');
//           localStorage.removeItem('deviceFingerprint');
//         }
//       } catch (error) {
//         console.error('Error tracking payment visit:', error);
//       }
//     };

//     // JavaScript Pixel Implementation
//     const fireJavaScriptPixel = (clickId, shortCode) => {
//       try {
//         const script = document.createElement('script');
//         script.type = 'text/javascript';
        
//         script.innerHTML = `
//           (function() {
//             const trackingData = {
//               clickId: '${clickId}',
//               shortCode: '${shortCode}',
//               timestamp: new Date().toISOString(),
//               referrer: document.referrer,
//               userAgent: navigator.userAgent,
//               screenResolution: \`\${window.screen.width}x\${window.screen.height}\`,
//               viewportSize: \`\${window.innerWidth}x\${window.innerHeight}\`
//             };

//             fetch('${process.env.REACT_APP_API_URL}/affiliate/pixel-track', {
//               method: 'POST',
//               headers: {
//                 'Content-Type': 'application/json',
//               },
//               body: JSON.stringify(trackingData)
//             }).catch(console.error);
//           })();
//         `;

//         document.body.appendChild(script);
//       } catch (error) {
//         console.error('Error firing JavaScript pixel:', error);
//       }
//     };

//     // Image Pixel Implementation
//     const fireImagePixel = (clickId, shortCode) => {
//       try {
//         const img = new Image(1, 1);
//         img.style.display = 'none';
        
//         const trackingUrl = new URL(`${process.env.REACT_APP_API_URL}/affiliate/pixel-track.gif`);
//         trackingUrl.searchParams.append('clickId', clickId);
//         trackingUrl.searchParams.append('shortCode', shortCode);
//         trackingUrl.searchParams.append('timestamp', new Date().toISOString());
//         trackingUrl.searchParams.append('ref', encodeURIComponent(document.referrer));

//         img.src = trackingUrl.toString();
//         document.body.appendChild(img);
//       } catch (error) {
//         console.error('Error firing image pixel:', error);
//       }
//     };

//     trackPaymentVisit();
//   }, []);

//   return null; // This component doesn't render anything
// };


// export default Tracker;

